const unixTimeConverter = (unixTimestamp, interval) => {
    const date = new Date().toString();
    const offsetIndex = date.indexOf('+')
    const GMTOffset = date.substr(offsetIndex + 1, 4);

    // Las horas vienen en GTM 00:00, para ajustar a la hora de
    // de España, se suman 2 horas en verano y 1 hora en invierno
    const timeToSum = GMTOffset === "0200" ? 7200 : 3600;
    const spainTime = unixTimestamp + timeToSum; 
    const dateObj = new Date(spainTime * 1000);

    if (interval === 'hour') {
        const utcString = dateObj.toUTCString();
        const hour = utcString.slice(-12, -7);

        return hour;

    } else if (interval === 'day') {
        const options = { weekday: 'long', 
                          year: 'numeric', 
                          month: 'long', 
                          day: 'numeric' };
        const day = dateObj.toLocaleDateString("es-ES", options);

        return day;
    }
}

export default unixTimeConverter;
